import { neutralForegroundActiveDelta, neutralForegroundFocusDelta, neutralForegroundHoverDelta, neutralPalette, } from "../fast-design-system";
import { colorRecipeFactory, swatchFamilyToSwatchRecipeFactory, SwatchFamilyType, } from "./common";
import { accessibleAlgorithm } from "./accessible-recipe";
/**
 * @internal
 */
export const neutralForeground = colorRecipeFactory(accessibleAlgorithm(neutralPalette, 14, 0, neutralForegroundHoverDelta, neutralForegroundActiveDelta, neutralForegroundFocusDelta));
/**
 * @internal
 */
export const neutralForegroundRest = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.rest, neutralForeground);
/**
 * @internal
 */
export const neutralForegroundHover = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.hover, neutralForeground);
/**
 * @internal
 */
export const neutralForegroundActive = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.active, neutralForeground);
/**
 * @internal
 */
export const neutralForegroundFocus = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.focus, neutralForeground);
